function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mini-Card/mapassetdisplay2",
  transform: "translate(-56.000000, -42.000000)",
  fill: "#ecc800",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Warning_170417",
  transform: "translate(56.000000, 42.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.8629045,12.5015557 L8.86986433,0.496577474 C8.48331437,-0.165525825 7.51693948,-0.165525825 7.13038952,0.496577474 L0.137349387,12.5015557 C-0.249200571,13.163659 0.22520165,14 0.998301564,14 L14.9843818,14 C15.7750522,14 16.2494544,13.163659 15.8629045,12.5015557 Z M7.78049627,4.17299315 C8.20218713,4.06845053 8.623878,4.27753578 8.81715297,4.66085874 C8.88743478,4.80024891 8.90500524,4.95706285 8.88743478,5.09645302 C8.85229388,5.53204729 8.83472343,5.96764157 8.81715297,6.42065961 C8.78201207,7.10018668 8.72930071,7.79713752 8.69415981,8.47666459 C8.67658935,8.68574984 8.67658935,8.8948351 8.6590189,9.12134412 C8.64144845,9.48724331 8.36032121,9.76602365 7.9913417,9.76602365 C7.63993265,9.76602365 7.34123496,9.48724331 7.3236645,9.13876789 C7.27095314,8.07591786 7.20067133,7.01306783 7.14795998,5.9502178 C7.13038952,5.67143746 7.11281907,5.37523335 7.09524862,5.09645302 C7.09524862,4.67828251 7.37637586,4.27753578 7.78049627,4.17299315 Z M8.00891215,12.1530803 C7.51693948,12.1530803 7.13038952,11.7523335 7.13038952,11.264468 C7.13038952,10.7766024 7.53450993,10.3758556 8.02648261,10.3758556 C8.51845528,10.3758556 8.90500524,10.7766024 8.90500524,11.2818917 C8.88743478,11.7523335 8.48331437,12.1530803 8.00891215,12.1530803 Z",
  id: "Shape"
}))));

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning.1b2fd4fd.svg";
export { ForwardRef as ReactComponent };